import { useEffect, useState } from 'react'
import useGetHassleFreeFlag from '../../../hooks/useGetHassleFreeFlag'

const useManageStep = ({
  orderItems,
  oidIndex,
  step,
  customerOrder,
  getSteps,
  setReqElem,
  setNoDataError,
  checkConditionalReason,
  setData,
  setStep,
  selectedPart,
}) => {
  const [loadingData, setLoading] = useState(false)
  const {
    isLifetimeReplacement,
    isHassleFree,
  } = useGetHassleFreeFlag()

  useEffect(() => {
    const widgetsIds = []

    setLoading(true)
    const {
      po_completion_date: poCompletionDate,
      brand,
      part_name: partName,
    } = orderItems[`${oidIndex(selectedPart)}`]

    getSteps(step, poCompletionDate, isLifetimeReplacement, isHassleFree, brand)
      .then(response => {
        setLoading(false)
        let newDescription = ''
        if (response.data) {
          /* below statements changed the days required to
          the message returns */
          newDescription = response.data.description
          if (response.pastDays && response.pastDays !== 90 && response.isPastReturn) {
            const search = /90\scalendar/gi
            const replaceWith = `${response.pastDays} calendar`
            response.data.description = newDescription.replace(search, replaceWith)
          }
          /* Diagnosis upload is only required on Catalytic Converter
            However the SSR service isn't yet supporting conditional
            response for this so the workaround would be changed the
            default required data from true to false
          */
          if (response.data.id === 'warrantyClaim' && brand !== 'Catalytic Converter') {
            response.data.widgets.forEach((widget, index) => {
              if (widget.id === 'documents') {
                response.data.widgets[`${index}`].required = false
              }
            })
          }

          /* this manipulates widget required
          property with the condition below */
          if (response.data.id === 'itemDefective' &&
          partName === 'Catalytic Converter' &&
          isHassleFree) {
            response.data.widgets.forEach((widget, index) => {
              if (widget.id === 'productImages') {
                response.data.widgets[`${index}`].required = true
              }
            })
          }

          setData(response.data)
          setStep(response.reasonId)
        }
        checkConditionalReason(response.data)
        const responseWidget = response.data.widgets
        responseWidget.map(({
          required, id, type,
        }) => {
          if (required) {
            widgetsIds.push({ id, type })
          }
          return widgetsIds
        })

        setReqElem(widgetsIds)
      }).catch(error => {
        setNoDataError(`${error.message} for fetching the return part reasons data `)
        setLoading(false)
        throw error
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, customerOrder, isLifetimeReplacement, isHassleFree])

  return {
    loadingData,
  }
}

export default useManageStep
